var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaixa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 24,
    viewBox: "0 0 51 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 50,
    height: 24,
    rx: 5.5,
    fill: "#F6F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9302 12.7448C12.2526 14.0884 10.8902 13.1385 11.0471 11.9941C11.183 11.0024 12.7458 9.80934 14.1525 11.2741L14.493 8.56285C12.0602 7.78094 10.1464 8.54684 8.75143 10.8606C7.96096 12.7024 8.26997 14.1497 9.67842 15.2022C10.6187 15.8248 11.8736 15.8999 13.4431 15.4278L13.9302 12.7448V12.7448Z",
    fill: "#157BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7947 15.7003L20.3191 8.44531H17.4058L13.7676 15.6372H16.57L16.8761 14.7605H18.8814L18.9949 15.7003H21.7947ZM18.5739 10.8746L18.6969 13.0737H17.647L18.4604 10.8746H18.5739Z",
    fill: "#157BC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0639 15.6014L26.1611 8.36523H23.4937L22.3965 15.6014H25.0639Z",
    fill: "#157BC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0272 11.8197H32.2338L31.136 9.64445L30.5028 8.38965H27.3057L29.0272 11.8197Z",
    fill: "#157BC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5849 15.6353H33.7723L32.0319 12.2051L29.9287 14.3916L30.5849 15.6353Z",
    fill: "#157BC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9509 8.44531L34.2998 15.6627L37.0996 15.6815L37.4212 14.7605H39.4265L39.54 15.7003H42.3399L40.8643 8.44531H37.9509ZM38.1697 13.0707L38.9832 10.8716H39.0967L39.2197 13.0707H38.1697V13.0707Z",
    fill: "#157BC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3142 8.4043L31.1406 9.64972L32.2384 11.8249L35.5113 8.4043H32.3142Z",
    fill: "#F8A23D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8458 12.2041L25.5918 15.5966H28.7606L29.9206 14.3906L32.0238 12.2041H28.8458Z",
    fill: "#F8A23D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixa);
export default __webpack_public_path__ + "static/media/caixa.d16e297c48bb190fba7ef994d9262e38.svg";
export { ForwardRef as ReactComponent };